import { Document, Partner, User } from '@app/shared';

export interface Chat {
  id: number;
  name: string;
  chatMessages: ChatMessage[];
}

export interface ChatMessage {
  id: number;
  chatId: number;
  userId: number;
  user: User;
  partner: Partner;
  message: string;
  createdOn: string;
  createdBy?: string; // Email del creador
  createdByName?: string; // Nombre completo del creador
  type: 'file' | 'text' | 'image' | 'change' | 'traceability';
  modifiedOn?: string;
  documents?: Document[];
  readers?: Readers[];
}

export interface ChatMessageCreate {
  message: string;
  type: 'file' | 'text' | 'image' | 'multiple';
  chatId: number;
  userId: number;
  authUserEmail: string; // Email del usuario autenticado que crea el mensaje (obligatorio)
  files?: File[];
}

export interface MessageDocument {
  id: number;
  messageId: number;
  documentId: number;
  document?: Document;
}

export interface Readers {
  id: number;
  chatMessageId: number;
  userId: number;
  readedOn: string;
}
